@use "~theme/breakpoints";

.prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  width: 100%;

  @include breakpoints.desktop {
    flex-direction: row;
    justify-content: center;
    padding: 12px 0;
  }
}

.promptHeadline {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  align-items: center;
  letter-spacing: 0.02em;
  float: left;
  color: var(--black);

  > img {
    margin-right: 0.5em;
  }

  // @include breakpoints.desktop {
    margin-right: 0.5em;
    margin-bottom: 0;
  // }
}

.somethingWentWrong {
  color: var(--red);
}

.modal {
  max-width: 607px;
  max-height: calc(100vh - 50px);
  height: calc(100vh - 50px);
}

.modalOverlay {
  align-items: initial;
}

.hideBackground{
  z-index: 1;
  background-color: white;
  padding: 0px 5px;
  top: -25px;
  @include breakpoints.desktop {
    position: relative;
  }
}